var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnknown = function SvgUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.77 8A6.77 6.77 0 1 1 1.23 8a6.77 6.77 0 0 1 13.54 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M8 16c-4.369 0-8-3.631-8-8 0-4.376 3.624-8 7.992-8C12.37 0 16 3.624 16 8c0 4.369-3.623 8-8 8m-.165-6.322c.408 0 .66-.258.66-.58v-.094c0-.455.258-.745.823-1.114.784-.517 1.349-.988 1.349-1.96 0-1.35-1.2-2.063-2.58-2.063-1.397 0-2.307.65-2.526 1.396-.04.125-.07.259-.07.4 0 .36.29.557.556.557.275 0 .455-.134.604-.322l.141-.196c.29-.47.706-.737 1.247-.737.73 0 1.208.415 1.208 1.027 0 .55-.337.816-1.043 1.31-.58.408-1.02.831-1.02 1.631v.102c0 .424.236.643.651.643m-.015 2.408c.47 0 .878-.368.878-.839 0-.47-.4-.847-.878-.847-.479 0-.879.384-.879.847s.408.84.879.84"
  })));
};
export default SvgUnknown;